/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowRejectionDetailDtoSchema = z.object({
  reasons: z.optional(z.array(z.string())),
  thesisAlignment: z.optional(z.string()),
  notes: z.string().nullish(),
});
